import { render, staticRenderFns } from "./ReviewedCard.vue?vue&type=template&id=0b4b000f"
import script from "./ReviewedCard.vue?vue&type=script&lang=js"
export * from "./ReviewedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports